<tec-modal
    [isVisible]="true"
    [title]="'PROCESSES.REVIEW.REJECT_DETAIL' | translate"
    [buttonPrimaryLabel]="'BUTTON.SAVE' | translate"
    [buttonSecondaryLabel]="'BUTTON.CANCEL' | translate"
    (closeEvent)="closeModal($event)"
>
    <ng-container body [formGroup]="form">
        @if (errorMsg) {
        <tec-alert status="error" [msg]="errorMsg" (closeAlert)="errorMsg = ''" />
        }
        <tec-tile [title]="'PROCESSES.REVIEW.REJECT_REASON' | translate" icon="icon-list-ticks">
            <tec-checkbox-group formControlName="reasons" [options]="checkboxOptions" [multiple]="true" />
            @if (showOtherReason) {
            <tec-textarea
                formControlName="otherReason"
                [placeholder]="'PROCESSES.BLOCK_IDENTITY_MODAL.WRITE_REASON' | translate"
                [hasError]="otherReasonControl.touched && otherReasonControl?.invalid"
                [maxlength]="300"
            />
            }
        </tec-tile>
        <tec-tile [title]="'PROCESSES.MENU.BLOCK_IDENTITY' | translate" [subtitle]="'PROCESSES.BLOCK_IDENTITY_MODAL.DESCRIPTION' | translate" icon="icon-lock">
            <form [formGroup]="blockParameters" class="block-parameters-form">
                @if (showOcrBlockOption) {
                <tec-card-select
                    formGroupName="ocr"
                    [tagImg]="{ icon: 'icon-card' }"
                    [title]="'PROCESSES.BLOCK_IDENTITY_MODAL.OCR_TITLE' | translate"
                    [tags]="
                        blockedIdentityParams.includes('ocr')
                            ? [{ label: 'PROCESSES.BLOCK_IDENTITY_MODAL.BLOCKED' | translate, status: 'error' }]
                            : [{ label: 'PROCESSES.BLOCK_IDENTITY_MODAL.ACTIVE' | translate, status: 'success' }]
                    "
                    [disabled]="form.get('blockParameters.ocr')?.disabled"
                    [selected]="form.get('blockParameters.ocr')?.value"
                    (selectedChange)="form.get('blockParameters.ocr').patchValue($event)"
                />
                }
                <tec-card-select
                    formGroupName="ip"
                    [tagImg]="{ icon: 'icon-map-pin' }"
                    [title]="'PROCESSES.BLOCK_IDENTITY_MODAL.IP_TITLE' | translate"
                    [tags]="
                        blockedIdentityParams.includes('ip')
                            ? [{ label: 'PROCESSES.BLOCK_IDENTITY_MODAL.BLOCKED' | translate, status: 'error' }]
                            : [{ label: 'PROCESSES.BLOCK_IDENTITY_MODAL.ACTIVE' | translate, status: 'success' }]
                    "
                    [disabled]="form.get('blockParameters.ip')?.disabled"
                    [selected]="form.get('blockParameters.ip')?.value"
                    (selectedChange)="form.get('blockParameters.ip').patchValue($event)"
                />
                @if (showFaceBlockOption) {
                <tec-card-select
                    formGroupName="face"
                    [tagImg]="{ icon: 'icon-user' }"
                    [title]="'PROCESSES.BLOCK_IDENTITY_MODAL.FACE_TITLE' | translate"
                    [tags]="
                        blockedIdentityParams.includes('face')
                            ? [{ label: 'PROCESSES.BLOCK_IDENTITY_MODAL.BLOCKED' | translate, status: 'error' }]
                            : [{ label: 'PROCESSES.BLOCK_IDENTITY_MODAL.ACTIVE' | translate, status: 'success' }]
                    "
                    [disabled]="form.get('blockParameters.face')?.disabled"
                    [selected]="form.get('blockParameters.face')?.value"
                    (selectedChange)="form.get('blockParameters.face').patchValue($event)"
                />
                }
            </form>
        </tec-tile>
    </ng-container>
</tec-modal>